import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.seal.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import '@wangeditor/editor/dist/css/style.css'; // 引入 css
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import selectPerson from '@/components/select-person';
import selectPersonGenera from '@/components/select-person/genera';
import config from '@/pathConfig';
import { queryOrganByUser, queryPositionByUser } from '@/api/commonApi.js';
import { queryNoticeFillDetails, judgeCountersign, judgeAppend, queryAuditRecord, noticeExamine, addAppendAudit, judgeAppendFinance, judgeDirectorExamine, judgeDirector, judgeDirectorJWB, querySign } from '@/api/notice/noticeApi.js';
export default {
  data: function data() {
    var userTabList = [{
      title: '组织岗位',
      value: 2
    }, {
      title: '组织岗位成员',
      value: 3
    }];
    return {
      userTabList: userTabList,
      config: config,
      colorItem: {
        '0': 'green',
        '1': 'red',
        '2': 'blue',
        '3': 'gray'
      },
      businessId: 2,
      // 业务id 1公文流转 2通知通告
      flowList: [],
      loading: false,
      modalLoading: false,
      current: 0,
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18
      },
      formObject: {},
      auditFormObj: {
        sign: '',
        // 签字信息
        auditStatus: 0,
        // 0 通过 1 不通过
        auditOpinion: '',
        // 审核意见
        isAppend: 0,
        // 是否追加审核 0 无 1 追加 2前签 3后签
        fillId: this.$route.query.id
      },
      optionVal: [],
      options: [],
      // 级联选择数据
      optionsAll: [],
      // 级联选择数据（全院）
      postList: [],
      // 岗位数据
      userInfo: this.$hdk.userInfo.get(),
      rules: {
        auditOpinion: [{
          required: false,
          message: '请输入审核意见'
        }, {
          max: 200,
          message: '字数超出限制200'
        }]
      },
      fileList: [],
      editor: null,
      toolbarConfig: {
        excludeKeys: ['fullScreen', 'group-video']
      },
      editorConfig: {
        placeholder: '请输入公告内容'
      },
      mode: 'default',
      // or 'default'
      visibleMode: false,
      appendTitle: '追加审核',
      selectOption: '',
      appendFormObj: {
        isAppend: '',
        // 是否追加审核 0 无 1 追加 2前签 3后签
        fillId: '',
        // 公告id
        records: [{
          appendname: '',
          organid: '',
          // 组织id
          typeid: '',
          // 组织类型
          userid: undefined,
          // 审核人
          postid: undefined,
          // 岗位id
          sort: '',
          // 排序
          customize: {
            postData: [],
            userData: []
          }
        }]
      },
      isCountersign: false,
      isAuditAppend: false,
      isAuditPresAppend: false,
      /* 中间参数 */
      typeId: '',
      organId: '',
      postId: '',
      isDirector: false,
      isDirectorJWB: false,
      signRecord: []
    };
  },
  mounted: function mounted() {
    this.getNoticeFillDetails();
  },
  methods: {
    /**
     * 根据id查询详情
     */
    getNoticeFillDetails: function getNoticeFillDetails() {
      var _this = this;
      var $route = this.$route,
        userInfo = this.userInfo;
      // 级联数据处理
      this.options = _.map(userInfo.organPostTree, function (item) {
        item.postList = _.map(item.postList, function (subItem) {
          return {
            label: subItem.postName,
            value: subItem.postId,
            children: null
          };
        });
        return {
          label: item.organName,
          value: item.organId,
          typeId: item.typeId,
          children: item.postList
        };
      });
      // 通知公告详情
      queryNoticeFillDetails($route.query.id).then(function (res) {
        _this.formObject = res.data.data;
        _this.formObject.organPostName = _this.formObject.organName + ' / ' + _this.formObject.postName;

        // 判断财务室主任
        judgeDirector({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirector = res.data.data;
        });
        // 判断是否是纪委办主任
        judgeDirectorJWB({
          organId: _this.formObject.organId,
          postId: _this.formObject.postId
        }).then(function (res) {
          _this.isDirectorJWB = res.data.data;
        });

        // 当前组织层级指定人员
        if (_this.formObject.range === 3) {
          _this.optionVal = _.map(_this.formObject.scope, function (item) {
            return item.userId;
          });
        } else {
          _this.formObject.customize = {};
          // sendType 发送类型 0 个人 1 组织 2 岗位
          _this.formObject.customize.userData = [];
          _this.formObject.customize.organData = [];
          _this.formObject.customize.postData = [];
          _.forEach(_this.formObject.scope, function (item) {
            if (item.sendType === 0) {
              _this.formObject.customize.userData.push({
                id: item.userId,
                name: item.userName,
                type: 1
              });
            }
            if (item.sendType === 1) {
              _this.formObject.customize.organData.push({
                id: item.organId,
                name: item.organName,
                typeId: item.typeId
              });
            }
            if (item.sendType === 2) {
              _this.formObject.customize.postData.push({
                id: item.postId,
                name: item.postName,
                type: 2
              });
            }
          });
          _this.formObject.customize.organId = _this.formObject.organId;
          _this.formObject.customize.postId = _this.formObject.postId;
        }
      });
      if ($route.query.type == 2) {
        // 判断能否加签
        judgeCountersign($route.query.id).then(function (res) {
          _this.isCountersign = res.data.data;
        });

        // 判断财务室主任(审核)时是否需要财务总监审核
        judgeDirectorExamine($route.query.id).then(function (res) {
          _this.isAuditAppend = res.data.data;
        });

        // 判断是否需要校长理事长审核(财务总监)
        judgeAppendFinance($route.query.id).then(function (res) {
          _this.isAuditPresAppend = res.data.data;
        });
      }
      // 流程记录查询
      queryAuditRecord($route.query.id).then(function (res) {
        _this.flowList = res.data.data;
      });
    },
    /**
     * 审核提交
     */
    onSubmit: function onSubmit() {
      var _this2 = this;
      var $confirm = this.$confirm,
        $set = this.$set,
        $refs = this.$refs,
        $message = this.$message,
        userInfo = this.userInfo,
        auditFormObj = this.auditFormObj,
        getNoticeFillDetails = this.getNoticeFillDetails,
        goBack = this.goBack;
      $refs.auditForm.validate(function (valid) {
        if (valid) {
          $confirm("确认提交吗?", "提示", {
            type: "info",
            confirmButtonText: "确认",
            cancelButtonText: "取消"
          }).then(function () {
            $refs.auditForm.validate(function (valid) {
              if (valid) {
                $set(auditFormObj, 'sign', userInfo.signImgUrl);
                _this2.loading = true;
                noticeExamine(_objectSpread({}, auditFormObj)).then(function (res) {
                  if (res.data.code == 200) {
                    $message.success('提交成功');
                    // getNoticeFillDetails();
                    goBack();
                  }
                  _this2.loading = false;
                });
              }
            });
          }).catch(function () {
            _this2.loading = false;
          });
        }
      });
    },
    /**
     * 排序校验
     */
    validateSort: function validateSort(row, index) {
      var $message = this.$message,
        appendFormObj = this.appendFormObj,
        signRecord = this.signRecord;
      _.forEach(appendFormObj.records, function (item, key) {
        if (key != index && item.sort === row.sort) {
          $message.error('排序重复请重新输入');
          row.sort = '';
          return;
        }
      });
      // 记录数据判断
      _.forEach(signRecord, function (item, key) {
        if (item.sort === row.sort) {
          $message.error('排序重复请重新输入');
          row.sort = '';
          return;
        }
      });
    },
    /**
     * 追加审核弹框
     */
    appendAudit: function appendAudit(flag) {
      var _this3 = this;
      var $set = this.$set,
        $refs = this.$refs,
        $route = this.$route,
        formObject = this.formObject,
        auditFormObj = this.auditFormObj,
        appendFormObj = this.appendFormObj,
        userInfo = this.userInfo;
      // 清除校验
      if ($refs.addForm) {
        $refs.addForm.clearValidate();
      }
      this.visibleMode = true;
      // 是否追加审核 0 无 1 追加 2前签 3后签
      if (flag === 2) {
        this.appendTitle = '加前签';
      } else if (flag === 3) {
        this.appendTitle = '加后签';
      }

      // 数据赋值
      $set(appendFormObj, 'isAppend', flag);
      $set(appendFormObj, 'fillId', formObject.id);
      this.appendFormObj.records = [{
        appendname: '',
        organid: '',
        typeid: '',
        userid: undefined,
        postid: '',
        sort: 1,
        customize: {
          postData: [],
          userData: []
        }
      }];
      // 查询加签记录指定排序
      querySign({
        fillId: formObject.id,
        appendType: flag
      }).then(function (res) {
        _this3.signRecord = res.data.data;
        // 排序计算
        if (_this3.signRecord.length > 0) {
          var sorts = [];
          _.forEach(_this3.signRecord, function (item, key) {
            return sorts.push(item.sort);
          });
          _this3.appendFormObj.records[0].sort = _.max(sorts) + 1;
        }
      });
    },
    onClose: function onClose() {
      this.visibleMode = false;
    },
    addDomain: function addDomain() {
      var appendFormObj = this.appendFormObj,
        signRecord = this.signRecord;

      // 排序计算
      var sorts = [];
      _.forEach(appendFormObj.records, function (item, key) {
        return sorts.push(item.sort);
      });

      // 加签记录排序计算
      if (appendFormObj.records.length === 0 && signRecord.length > 0) {
        _.forEach(signRecord, function (item, key) {
          return sorts.push(item.sort);
        });
      }
      this.appendFormObj.records.push({
        appendname: '',
        organid: '',
        typeid: '',
        userid: undefined,
        postid: '',
        sort: _.max(sorts) ? _.max(sorts) + 1 : 1,
        customize: {
          postData: [],
          userData: []
        }
      });
    },
    removeDomain: function removeDomain(item) {
      var signRecord = this.signRecord,
        appendFormObj = this.appendFormObj;
      var index = this.appendFormObj.records.indexOf(item);
      if (index !== -1) {
        this.appendFormObj.records.splice(index, 1);
      }
      var sorts = [0];
      // 加签记录排序计算
      if (signRecord.length > 0) {
        _.forEach(signRecord, function (item, key) {
          return sorts.push(item.sort);
        });
      }

      // 删除计算自动排序
      _.forEach(appendFormObj.records, function (row, key) {
        row.sort = _.max(sorts) + (key + 1);
      });
    },
    /**
     * 追加审核保存
     */
    handleOk: function handleOk() {
      var _this4 = this;
      var $refs = this.$refs,
        $message = this.$message,
        appendFormObj = this.appendFormObj,
        getNoticeFillDetails = this.getNoticeFillDetails,
        goBack = this.goBack;
      if (appendFormObj.records.length === 0) {
        $message.error('请添加数据');
        return;
      }
      $refs.addForm.validate(function (valid) {
        if (valid) {
          // 选择的成员或者岗位数据处理
          _.map(appendFormObj.records, function (item) {
            if (item.customize.userData.length > 0) {
              item.organid = item.customize.userData[0].organId;
              item.postid = item.customize.userData[0].postId;
              item.typeid = item.customize.userData[0].typeId;
              item.userid = item.customize.userData[0].actorId;
            }
            if (item.customize.postData.length > 0) {
              item.organid = item.customize.postData[0].organId;
              item.typeid = item.customize.postData[0].typeId;
              item.postid = item.customize.postData[0].actorId;
            }
          });
          _this4.modalLoading = true;
          addAppendAudit(_objectSpread({}, appendFormObj)).then(function (res) {
            if (res.data.code == 200) {
              $message.success('保存成功');
              _this4.visibleMode = false;
              // 如果是前签返回到列表，否则刷新当前页面
              if (appendFormObj.isAppend === 2) {
                goBack();
              } else {
                getNoticeFillDetails();
              }
            }
            _this4.modalLoading = false;
          });
        }
      });
    },
    popupVis: function popupVis(row) {
      var typeId = this.typeId,
        organId = this.organId;
      if (organId) {
        row.organid = organId;
        row.typeid = typeId;
      } else {
        row.organid = '';
        row.typeid = '';
        row.postid = undefined;
        row.userid = undefined;
      }
    },
    postSelect: function postSelect(value, option) {
      var $set = this.$set,
        typeId = this.typeId,
        organId = this.organId,
        postId = this.postId,
        formObject = this.formObject,
        getPositionByUser = this.getPositionByUser;
      $set(formObject, 'organId', organId);
      $set(formObject, 'postId', value);
      getPositionByUser();
    },
    postChange: function postChange(row) {
      if (!row.postid) {
        row.userid = undefined;
      }
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    /**
     * 编辑器
     */
    onCreated: function onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      this.editor.disable();
    },
    auditStatusChange: function auditStatusChange(e) {
      if (e.target.value === 1) {
        this.rules.auditOpinion[0].required = true;
      } else {
        this.rules.auditOpinion[0].required = false;
      }
    },
    postOrUserChange: function postOrUserChange(row) {},
    /**
     * 返回列表页
     */
    goBack: function goBack() {
      var $route = this.$route;
      if ($route.query.type == 3) {
        this.$router.push({
          path: '/docNotice/notice/list'
        });
      } else if ($route.query.type == 4) {
        this.$router.push({
          path: '/docNotice/notice/publish'
        });
      } else if ($route.query.path == 'system') {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: '/docNotice/notice/audit'
        });
      }
    }
  },
  components: {
    Editor: Editor,
    Toolbar: Toolbar,
    selectPerson: selectPerson,
    selectPersonGenera: selectPersonGenera
  }
};